import { VipCustomerDto } from '../vip-customers';

export type DeadlineFilter = 0 | 189 | 190 | 191;

export type ticketType = {
  ticketId: number; //Phieu yeu cau
  customerCode: string;
  organizationUnitCode: string;
  customerRequestName: string;
  customerRequestPhoneNumber: string;
  customerRequestAddress: string;
  customerRequestCicNumber: number;
  customerRequestCicIssueDate: string;
  customerRequestCicIssuePlace: number;
  customerRequestCicType: number;
  numOfRequests: number;
  content: string;
  isPriority: boolean;
  isDoubleCheck: boolean;
  isRequestMultipleTime: boolean;
  isNotOnTime: boolean;
  channelId: number;
  channel: {
    channelId: number;
    channelCode: string;
    channelName: string;
  };
  serviceTypeId: number;
  serviceType: {
    serviceTypeId: number;
    code: string;
    name: string;
  };
  administrativeUnitId: number;
  administrativeUnit: {
    administrativeUnitId: number;
    administrativeUnitCode: number;
    administrativeUnitName: string;
  };
  cmisRequestId: number;
  appointmentDate: string;
  statusId: number;
  status: {
    optionId: number;
    code: string;
    name: string;
  };
  latitude: number;
  longitude: number;
  createdBy: number;
  createdByName: string;
  createdAt: string;
  createdAtDateOnly: string;
  updatedAt: string;
  closedAt: string;
  closedAtDateOnly: string;
  closedBy: string;
  additionalInfo: {
    ticketId: number;
    phaseNumber: number;
    usagePurpose: string;
    outageAt: string;
    outageReasonId: number;
    powerRestorationAt: string;
    isOutageEntireArea: boolean;
    isNotRequestToSendSms: boolean;
    incidenAddress: string;
    incidentAdministrativeUnitId: number;
    createdAt: string;
    createdBy: number;
    createdByName: string;
    firstFieldEmployee: string;
    secondFieldEmployee: string;
  };
  ticketDistributions: [
    {
      ticketDistributionId: number;
      ticketId: number;
      fromOrganizationUnitId: number;
      toOrganizationUnitId: number;
      isActive: number;
      isPrimary: boolean;
      primaryTeamId: number;
      primaryTeamName: string;
      primaryTeamShortName: string;
      isCollaborative: boolean;
      collaborativeTeamId: number;
      collaborativeTeamName: string;
      collaborativeTeamShortName: string;
      fromTeamId: number;
      toTeamId: number;
      assigneeId: number;
      assigneeDate: string;
      assigneeName: string;
      assigneeShortName: string;
      createdBy: number;
      createdAt: string;
    }
  ];
};

export type tickets = ticketType[];

export type Option = {
  optionId: number;
  code: string;
  name: string;
};

export interface TicketDetail {
  distributionStationName?: string;
  ticketId: number;
  customerCode: string;
  organizationUnitCode: string;
  organizationUnit: {
    organizationUnitId: number;
    code: string;
    name: string;
    shortName: string;
  };
  customerRequestName: string;
  customerRequestPhoneNumber: string;
  customerRequestAddress: string;
  customerRequestCicNumber: string;
  customerRequestCicIssueDate: string;
  customerRequestCicIssuePlace: string;
  customerRequestCicType: number;
  numOfRequests: number;
  content: string;
  isPriority: boolean;
  isDoubleCheck: boolean;
  isRequestMultipleTime: boolean;
  isNotOnTime: boolean;
  channelId: number;
  channel: {
    channelId: number;
    channelCode: string;
    channelName: string;
  };
  serviceTypeId: number;
  serviceType: {
    serviceTypeId: number;
    code: string;
    name: string;
    childrenCompact: [string];
    parentCompact: {
      serviceTypeId: number;
      code: string;
      name: string;
      childrenCompact: [string];
      parentCompact: string;
      serviceTypeCmisId: number;
      isRequiredCmis: true;
    };
    serviceTypeCmisId: number;
    isRequiredCmis: true;
  };
  administrativeUnitId: number;
  administrativeUnit: {
    administrativeUnitId: number;
    administrativeUnitCode: string;
    administrativeUnitName: string;
  };
  cmisRequestId: string;
  appointmentDate: string;
  statusId: number;
  status: {
    optionId: number;
    code: string;
    name: string;
  };
  latitude: number;
  longitude: number;
  createdBy: number;
  createdByName: string;
  createdAt: string;
  createdAtDateOnly: string;
  updatedAt: string;
  closedAt: string;
  closedAtDateOnly: string;
  closedBy: number;
  ticketEvents: {
    ticketEventId: number;
    batchUuid: string;
    ticketId: number;
    organizationUnitId: number;
    organizationUnitCode: string;
    organizationUnitName: string;
    previousContent: string;
    currentContent: string;
    actionTypeId: number;
    actionType: {
      optionId: number;
      code: string;
      name: string;
    };
    shiftCode: string;
    createdAt: string;
    createdBy: number;
    createdByName: string;
  }[];
  files: {
    id: number;
    ticketId: number;
    ticketEventId: number;
    fileId: number;
    createdBy: number;
    createdAt: string;
    updatedAt: string;
  }[];
  additionalInfo: {
    ticketId: number;
    phaseNumber: number;
    usagePurpose: string;
    outageAt: string;
    outageReasonId: number;
    powerRestorationAt: string;
    isOutageEntireArea: boolean;
    isNotRequestToSendSms: boolean;
    incidenAddress: string;
    incidentAdministrativeUnitId: number;
    createdAt: string;
    createdBy: number;
    createdByName: string;
    firstFieldEmployee: string;
    secondFieldEmployee: string;
  };
  customer: {
    customerId: number;
    customerCode: string;
    customerName: string;
    customerAddress: string;
    customerEmail: string;
    customerPhoneNumber: string;
    customerCicNumber: number;
    customerCicIssueDate: string;
    customerCicIssuePlace: string;
    status: boolean;
    organizationUnitCode: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: string;
    createdBy: string;
    updatedBy: string;
    deletedBy: string;
    administrativeUnitCode: string;
    meterSerialNumber: number;
    routeCode: string;
    meterPointCode: string;
    organizationUnit: {
      organizationUnitId: number;
      code: string;
      name: string;
      shortName: string;
      organizationUnitClassifyId: number;
      parent: string;
    };
    distributionStationCode: string;
    distributionStationName: string;
    outgoingLineCode: string;
  };
  ticketHoldManager: [
    {
      ticketHoldManagerId: number;
      ticketId: number;
      isActive: true;
      estimatedEndDate: string;
      content: string;
      obstacleSourceId: number;
      obstacleSource: {
        optionId: number;
        code: string;
        name: string;
      };
      createdBy: number;
      updatedBy: number;
      closedBy: number;
      createdAt: string;
      updatedAt: string;
      closedAt: string;
    }
  ];
  resolution: string;
  receptionBy: number;
  receptionDate: string;
  ticketDistributions: [
    {
      ticketDistributionId: number;
      ticketId: number;
      fromOrganizationUnitId: number;
      toOrganizationUnitId: number;
      isActive: number;
      isPrimary: boolean;
      primaryTeamId: number;
      primaryTeamName: string;
      primaryTeamShortName: string;
      isCollaborative: boolean;
      collaborativeTeamId: number;
      collaborativeTeamName: string;
      collaborativeTeamShortName: string;
      fromTeamId: number;
      toTeamId: number;
      assigneeId: number;
      assigneeDate: string;
      assigneeName: string;
      assigneeShortName: string;
      createdBy: number;
      createdAt: string;
    }
  ];
  appctHistory?: [
    {
      appctHistoryId: number,
      ticketId: number,
      isTransferred: boolean,
      directCommanderCode: string,
      directCommanderName: string,
      directCommanderPersonalNumber: string,
      workerCode: string,
      workerName: string,
      workerPersonalNumber: string,
      createdAt: string
    }
  ];
  ticketDeadline: {
    id: number,
    expectedCompletionDate: string,
    actualCompletionDate: string | null,
    isOverdue: false
  }

  vipCustomer?: VipCustomerTicketDto;
}

export type VipCustomerTicketDto = {
  vipCustomerId: number,
  code: string,
  name: string,
  note: string,
  color: string,
  phoneNumber: string,
  createdBy: number,
  updatedBy: number,
  deletedBy: number,
  createdAt: string,
  updatedAt: string,
  deletedAt: string,
  createdByUser: {
  userId: number,
    fullName: string,
    shortName: string,
    avatar: number,
    employeeId: string,
    email: string,
    extensionId: string,
    organizationUnitId: number,
    organizationUnitName: string,
    username: string
  },
    updatedByUser: {
      userId: number,
        fullName: string,
        shortName: string,
        avatar: number,
        employeeId: string,
        email: string,
        extensionId: string,
        organizationUnitId: number,
        organizationUnitName: string,
        username: string
    },
    customerGroupId: number,
      customerGroup: {
    customerGroupId: number,
      name: string,
      color: string
  }
}

export type TicketCountRequest = {
  status: string;
  isObstacleTickets?: boolean;
  fromDate?: string;
  toDate?: string;
  isPriority?: boolean;
};

export type RequestData = {
  pageIndex: number;
  pageSize: number;
  ticketId: string;
  fromOrganizationUnitId?: number;
  toOrganizationUnitId?: number;
  toTeamId?: number;

  isPrimary: number;
  primaryOrganizationUnitId: number;
  isCollaborative: number;
  collaborativeOrganizationUnitId: number;
  fromDate: string;
  toDate: string;
  isActive: true;

  filterKey?: number;
  filterValue?: string;
  isObstacleTickets?: boolean;
  serviceTypeId?: number[];
  isSendToCmis?: boolean;
  isAssigned?: boolean;

  nearDeadlineMinutes?: number | null | 0;  //  Số phút trước hạn
  deadlineFilterType?: 0 | 189 | 190 | 191; //  Lọc theo thời gian

  isPriority?: boolean | null,

  //Status of ticket
  status: string;
};

export type Pagination = {
  pageIndex: number;
  pageSize: number;
};

// Transfer Cmis Services
export type CmisServicesRequestData = {
  pageIndex: number;
  pageSize: number;
  code: string;
  prefixCode: string;
  isLoadAll: boolean;
};
export type CmisServicesResponseData = {
  serviceTypeCmisId: number;
  code: string;
  name: string;
  description: string;
  cmisPrefixCode: string;
  priority: number;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
};

//PATCH TRANSFER TO
export interface TransferToUnit {
  toUnit: string;
  ticketId: number;
}

export interface TransferSupportUnit {
  fromUnitId: number, // nguoi dung
  toUnitId: number, // API danh sách đơn vị
  fromTeamId: number, // nguoi dung
  toTeamId: number, // 
  reason: string

  ticketId: number,
}

// PATCH Change Tickets Status
export interface ChangeStatus {}

export interface InprogressTickets {
  ticketId: number;
  processingContent: string;
  contactEventId?: number;
  outageReasonId?: number;
  powerRestorationAt?: Date;

  isRequestMultipleTime: boolean;
  isNotOnTime: boolean;
  isOutageEntireArea: boolean;
  isNotRequestToSendSms: boolean;

  uploadFileIds?: number[]
}

export interface CompleteTickets {
  ticketId: number;
  processingContent: string;
  outageReasonId?: number;
  powerRestorationAt?: string;
}

export interface OrganizationUnitChildren {
  organizationUnitId: number;
  code: string;
  name: string;
  shortName: string;
}

export interface CollaborationTicket {
  processingContent: string;
  collaborationTeamId: number;
  fromTeamId: number;
}

export interface CollaborationRequest {
  collaborationDetail: CollaborationTicket;
  ticketId: number;
}

export interface TransferTicket {
  processingContent: string;
  toTeamId: number;
}

export interface TransferTicketRequest {
  transferDetail: TransferTicket;
  ticketId: number;
}

export type UpdateObstacleTicketRequest = {
  ticketId: number;
  content: string;
  estimatedEndDate: string;
  obstacleSourceId: number;

  ticketHoldManagerId: number;
};

export type CompleteCollaborationTicketRequest = {
  ticketId: number;
  processingContent: string;
};

export type TransferCmis = {
  ticketId: number;
  serviceTypeCmisId: number;
};

export type AssignEmployeeTicketRequest = {
  ticketId: number;
  assigneeId: number;
};

export interface AssignCrmAppTaskDto {
  SODIENTHOAI?: string;
  CASE_ID_SOURCE: string;
  FIELD_EMPLOYEE_POSITION: 1 | 2;
}

export type CmisRequestProcessingProgressEvent = {
  startDate: string;
  processingContent: string;
  requestTypeName: string;
  jobCode: string;
};

export type OrganizationUnitDetail = {
  organizationUnitId: number;
  code: string;
  name: string;
  shortName: string;
  description: string;
  isSystem: true;
  level: number;
  parentId: number;
  parent: {
    organizationUnitId: number;
    code: string;
    name: string;
    shortName: string;
    organizationUnitClassifyId: number;
    parent: string;
  };
  createdBy: number;
  updatedBy: number;
  deletedBy: number;
  createdAt: string;
  updatedAt: string;
  serviceTypes: [
    {
      serviceTypeId: number;
      code: string;
      name: string;
      childrenCompact: [string];
      parentCompact: string;
      serviceTypeCmisId: number;
      isRequiredCmis: true;
    }
  ];
  organizationUnitClassifyId: number;
  organizationUnitClassify: {
    optionId: number;
    code: string;
    name: string;
  };
  headUserId: number;
  headUser: {
    userId: number;
    email: string;
    fullName: string;
    shortName: string;
    avatar: number;
    employeeId: string;
    extensionId: string;
  };
  deputyUsers: [
    {
      userId: number;
      email: string;
      fullName: string;
      shortName: string;
      avatar: number;
      employeeId: string;
      extensionId: string;
    }
  ];
  countServiceTypes: number;
  countUsers: number;
  users: [
    {
      userId: number;
      email: string;
      fullName: string;
      shortName: string;
      avatar: number;
      employeeId: string;
      extensionId: string;
    }
  ];
  countChildren: number;
  children: {
    organizationUnitId: number;
    code: string;
    name: string;
    shortName: string;
    organizationUnitClassifyId: number;
    parent: string;
  };
};

export type OrganizationUnitService = {
  serviceTypeId: number;
  code: string;
  name: string;
  childrenCompact?: string[];
  parentCompact?: string;
  serviceTypeCmisId: number;
  isRequiredCmis: boolean;
};

export type OptionDetail = {
  optionId: number;
  code: string;
  name: string;
};
export type CreateObstacleTicketRequest = {
  ticketId: number;
  content: string;
  estimatedEndDate: string;
  obstacleSourceId: number;
};

export interface FieldEmployeeDto {
  id: number;
  soDienThoai: string;
  MA_DVIQLY_TCT: string;
  MA_DVIQLY_CT: string;
  MA_DVIQLY_DL: string;
  MA_DOI: string;
  hoten: string;
  trangthai: number;
  state_online: number;
  ngay_tao: string;
  RN: string;
}

export interface GetFieldEmployeesResponse {
  state: number;
  description: string;
  data: FieldEmployeeDto[];
  current_page: number;
  number_of_page: number;
  total_record: number;
  total_page: number;
}

export interface nhanVienDto {
  name: string;
  phone_number: number;
  status: string;
  color: string;
}

export interface FieldTaskDto {
  case_id: number;
  nhanvien: nhanVienDto[];
}

export interface GetFieldTasksResponse {
  state: number;
  description: string;
  data: FieldTaskDto[];
}

export type UserInOrganizationUnitResponse = {
  userId: number;
  fullName: string;
  shortName: string;
  avatar: number;
  employeeId: string;
  email: string;
  extensionId: string;
};

//Default Data
const defaultTicketDetail: TicketDetail = {
  ticketId: 0,
  customerCode: '',
  organizationUnitCode: '',
  organizationUnit: {
    organizationUnitId: 0,
    code: '',
    name: '',
    shortName: ''
  },
  customerRequestName: '',
  customerRequestPhoneNumber: '',
  customerRequestAddress: '',
  customerRequestCicNumber: '',
  customerRequestCicIssueDate: '',
  customerRequestCicIssuePlace: '',
  customerRequestCicType: 0,
  numOfRequests: 0,
  content: '',
  isPriority: false,
  isDoubleCheck: false,
  isRequestMultipleTime: false,
  isNotOnTime: false,
  channelId: 0,
  channel: {
    channelId: 0,
    channelCode: '',
    channelName: ''
  },
  serviceTypeId: 0,
  serviceType: {
    serviceTypeId: 0,
    code: '',
    name: '',
    childrenCompact: [''],
    parentCompact: {
      serviceTypeId: 0,
      code: '',
      name: '',
      childrenCompact: [''],
      parentCompact: '',
      serviceTypeCmisId: 0,
      isRequiredCmis: true
    },
    serviceTypeCmisId: 0,
    isRequiredCmis: true
  },
  administrativeUnitId: 0,
  administrativeUnit: {
    administrativeUnitId: 0,
    administrativeUnitCode: '',
    administrativeUnitName: ''
  },
  cmisRequestId: '',
  appointmentDate: '',
  statusId: 0,
  status: {
    optionId: 0,
    code: '',
    name: ''
  },
  latitude: 0,
  longitude: 0,
  createdBy: 0,
  createdByName: '',
  createdAt: '',
  createdAtDateOnly: '',
  updatedAt: '',
  closedAt: '',
  closedAtDateOnly: '',
  closedBy: 0,
  ticketEvents: [],
  files: [],
  additionalInfo: {
    ticketId: 0,
    phaseNumber: 0,
    usagePurpose: '',
    outageAt: '',
    outageReasonId: 0,
    powerRestorationAt: '',
    isOutageEntireArea: false,
    isNotRequestToSendSms: false,
    incidenAddress: '',
    incidentAdministrativeUnitId: 0,
    createdAt: '',
    createdBy: 0,
    createdByName: '',
    firstFieldEmployee: '',
    secondFieldEmployee: ''
  },
  customer: {
    customerId: 0,
    customerCode: '',
    customerName: '',
    customerAddress: '',
    customerEmail: '',
    customerPhoneNumber: '',
    customerCicNumber: 0,
    customerCicIssueDate: '',
    customerCicIssuePlace: '',
    status: true,
    organizationUnitCode: '',
    createdAt: '',
    updatedAt: '',
    deletedAt: '',
    createdBy: '',
    updatedBy: '',
    deletedBy: '',
    administrativeUnitCode: '',
    meterSerialNumber: 0,
    routeCode: '',
    meterPointCode: '',
    organizationUnit: {
      organizationUnitId: 0,
      code: '',
      name: '',
      shortName: '',
      organizationUnitClassifyId: 0,
      parent: ''
    },
    distributionStationCode: '',
    distributionStationName: '',
    outgoingLineCode: ''
  },
  ticketHoldManager: [
    {
      ticketHoldManagerId: 0,
      ticketId: 0,
      isActive: true,
      estimatedEndDate: '',
      content: '',
      obstacleSourceId: 0,
      obstacleSource: {
        optionId: 0,
        code: '',
        name: ''
      },
      createdBy: 0,
      updatedBy: 0,
      closedBy: 0,
      createdAt: '',
      updatedAt: '',
      closedAt: ''
    }
  ],
  resolution: '',
  receptionBy: 0,
  receptionDate: '',
  ticketDistributions: [
    {
      ticketDistributionId: 0,
      ticketId: 0,
      fromOrganizationUnitId: 0,
      toOrganizationUnitId: 0,
      isActive: 0,
      isPrimary: false,
      primaryTeamId: 0,
      primaryTeamName: '',
      primaryTeamShortName: '',
      isCollaborative: false,
      collaborativeTeamId: 0,
      collaborativeTeamName: '',
      collaborativeTeamShortName: '',
      fromTeamId: 0,
      toTeamId: 0,
      assigneeId: 0,
      assigneeDate: '',
      assigneeName: '',
      assigneeShortName: '',
      createdBy: 0,
      createdAt: ''
    }
  ],
  ticketDeadline: {
    id: 0,
    expectedCompletionDate: "",
    actualCompletionDate: null,
    isOverdue: false
  },
  vipCustomer: {
    vipCustomerId: 0,
    code: '',
    name: '',
    note: '',
    color: '',
    phoneNumber: '',
    createdBy: 0,
    updatedBy: 0,
    deletedBy: 0,
    createdAt: '',
    updatedAt: '',
    deletedAt: '',
    createdByUser: {
      userId: 0,
      fullName: '',
      shortName: '',
      avatar: 0,
      employeeId: '',
      email: '',
      extensionId: '',
      organizationUnitId: 0,
      organizationUnitName: '',
      username: ''
    },
    updatedByUser: {
      userId: 0,
      fullName: '',
      shortName: '',
      avatar: 0,
      employeeId: '',
      email: '',
      extensionId: '',
      organizationUnitId: 0,
      organizationUnitName: '',
      username: ''
    },
    customerGroupId: 0,
    customerGroup: {
      customerGroupId: 0,
      name: '',
      color: ''
    }
  } as VipCustomerTicketDto
};

export default defaultTicketDetail;
